import { Dialog, DialogContent, Button, DialogActions } from "@mui/material";
import { useSelector } from "react-redux";
import OrderSummaryPDF from "./ProductSummaryPDF";

const ProductSummaryModalPDF = ({ open, handleClose }) => {
  const { defaultDataPedido } = useSelector(({ pedido }) => pedido);
  const { defaultData } = useSelector(({ producto }) => producto);

  return (
    <Dialog fullWidth maxWidth="lg" open={open} onClose={handleClose}>
      <DialogContent>
        <OrderSummaryPDF
          defaultDataDetail={defaultDataPedido}
          producto={defaultData}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color={"secondary"} variant="contained">
          Cancelar
        </Button>
      </DialogActions>
    </Dialog>
  );
};
export default ProductSummaryModalPDF;
